import { selectWidgetsWithChat } from 'ducks/widgets/selectors'
import { CHAT_PAGE } from 'subapps/chat/pages'
import { selectCurrentQueryId } from 'ducks/searches/selectors'
import { selectRoomIdFromUrl } from 'ducks/chat/selectors/rooms'
import {
  queryIdToQuery,
  defaultFolderItemQueryId,
} from 'ducks/searches/utils/query'
import { queryParams } from 'util/params'
import { selectCurrentUser } from 'ducks/currentUser/selectors/base'
import {
  selectPrefersAllMailboxesSectionVisible,
  selectPrefersUnifiedInbox,
} from 'ducks/currentUser/selectors/preferences'
import { selectCurrentAgents } from 'ducks/agents/selectors'
import { selectIsInInbox, selectIsInSettings } from 'selectors/location'
import { selectAccessibleCurrentChannels } from 'ducks/channels/selectors'
import {
  BUILD_FROM_WIDGETS,
  TOGGLE_COLLECTION,
  OPEN_ONE_COLLECTION,
  BUILD_INBOX_MENU_FROM_MAILBOXES,
} from '../actionTypes/collections'
import { selectChatFolders, selectFolders } from '../selectors/folders'

export function doToggleCollection({ collectionId, event }) {
  return dispatch => {
    if (queryParams().channelId === collectionId) {
      event.preventDefault()
    }
    return dispatch({
      type: TOGGLE_COLLECTION,
      payload: {
        collectionId,
      },
    })
  }
}

export function doOpenOneCollection({ collectionId, event }) {
  return dispatch => {
    if (queryParams().channelId === collectionId) {
      event.preventDefault()
    }
    return dispatch({
      type: OPEN_ONE_COLLECTION,
      payload: {
        collectionId,
      },
    })
  }
}

export function doBuildMenuFromWidgets({ autoRedirect = true } = {}) {
  return (dispatch, getState) => {
    const state = getState()
    const widgets = selectWidgetsWithChat(state)
    const folders = selectChatFolders(state)
    const currentQueryId = selectCurrentQueryId(state)
    const prefersAllMailboxesSectionVisible = selectPrefersAllMailboxesSectionVisible(
      state
    )
    const prefersUnifiedInbox = selectPrefersUnifiedInbox(state)

    dispatch({
      type: BUILD_FROM_WIDGETS,
      payload: {
        widgets,
        folders,
        prefersAllMailboxesSectionVisible,
        prefersUnifiedInbox,
      },
    })
    // Kevin R: I would have preferred dispatching BUILD_FROM_WIDGETS
    // and the doRedirectToDefaultCollectionAndFolder in a batch action
    // but for some reason the redux first router doesnt play well with
    // out batching system
    if (!currentQueryId && autoRedirect) {
      dispatch(doRedirectToDefaultCollectionAndFolder())
    }
  }
}

export function doRedirectToDefaultCollectionAndFolder() {
  return (dispatch, getState) => {
    const state = getState()
    const widgets = selectWidgetsWithChat(state)
    const folders = selectChatFolders(state)
    const prefersAllMailboxesSectionVisible = selectPrefersAllMailboxesSectionVisible(
      state
    )
    const prefersUnifiedInbox = selectPrefersUnifiedInbox(state)

    if (widgets.length === 0 || folders.length === 0) return
    const query = queryIdToQuery(
      defaultFolderItemQueryId({
        widgets,
        folders,
        prefersAllMailboxesSectionVisible,
        prefersUnifiedInbox,
      })
    )
    const conversationId = selectRoomIdFromUrl(state)
    if (conversationId) {
      query.conversationId = conversationId
    }
    dispatch({
      type: CHAT_PAGE,
      payload: {},
      meta: {
        query,
      },
    })
  }
}

export function doBuildInboxMenuFromMailboxes() {
  return (dispatch, getState) => {
    const state = getState()
    const isInInbox = selectIsInInbox(state)
    const isInSettings = selectIsInSettings(state)
    const mailboxes = selectAccessibleCurrentChannels(state)
    const folders = selectFolders(state)
    const agents = selectCurrentAgents(state)
    const currentUser = selectCurrentUser(state)

    // Kevin R: 2022-01-31
    // TODO: We need to replace this with a better check that ensures
    // that all the data we need to rebuild the menu has been bootstrapped
    // for now, if your inside inbox, then the data is available. Quick
    // and easy check
    if (!(isInInbox || isInSettings)) return null

    return dispatch({
      type: BUILD_INBOX_MENU_FROM_MAILBOXES,
      payload: {
        folders,
        mailboxes,
        agents,
        currentUser,
      },
    })
  }
}
